class CustomGallerySlider {
  constructor(section) {
    this.section = section;
    this.swiper = null;

    this.init();

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.init();
      }, 200);
    });
  }

  init() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    const swiperEl = this.section.querySelector('.gallery-swiper');
    if (!swiperEl) return;
    
    const desktopSlider =
      this.section.dataset.desktopSlider === 'true';

    const mobileSlider =
      this.section.dataset.mobileSlider === 'true';

    const desktopSlides =
      parseFloat(this.section.dataset.desktopSlides || 4);

    const mobileSlides =
      parseFloat(this.section.dataset.mobileSlides || 1.2);

    const desktopGap =
      parseInt(this.section.dataset.desktopGap || 20);

    const mobileGap =
      parseInt(this.section.dataset.mobileGap || 10);

    const loop =
      this.section.dataset.loop === 'true';

    const autoplayEnabled =
      this.section.dataset.autoplay === 'true';

    const speed =
      parseInt(this.section.dataset.speed || 3000);

    const isMobile = window.innerWidth < 750;

    const enableSlider = isMobile
      ? mobileSlider
      : desktopSlider;

    if (!enableSlider) {
      this.enableGrid(swiperEl, isMobile);
      return;
    }

    this.enableSwiper(
      swiperEl,
      desktopSlides,
      mobileSlides,
      desktopGap,
      mobileGap,
      loop,
      autoplayEnabled,
      speed
    );
  }

  enableGrid(swiper) {
    swiper.classList.add('gallery-grid-mode');

    const wrapper = swiper.querySelector('.swiper-wrapper');

    wrapper.style.display = 'grid';
    wrapper.style.gridTemplateColumns =
      window.innerWidth < 750
        ? 'repeat(2,1fr)'
        : `repeat(${this.section.dataset.desktopSlides},1fr)`;

    wrapper.style.gap =
      window.innerWidth < 750
        ? `${this.section.dataset.mobileGap}px`
        : `${this.section.dataset.desktopGap}px`;

    wrapper.style.transform = 'none';

    wrapper.querySelectorAll('.swiper-slide').forEach((slide) => {
      slide.style.width = '100%';
      slide.style.marginRight = '0';
    });

    const next = swiper.querySelector('.swiper-button-next');
    const prev = swiper.querySelector('.swiper-button-prev');
    const pagination = swiper.querySelector('.swiper-pagination');

    if (next) next.style.display = 'none';
    if (prev) prev.style.display = 'none';
    if (pagination) pagination.style.display = 'none';
  }

  enableSwiper(
    swiper,
    desktopSlides,
    mobileSlides,
    desktopGap,
    mobileGap,
    loop,
    autoplayEnabled,
    speed
  ) {
    swiper.classList.remove('gallery-grid-mode');

    const wrapper = swiper.querySelector('.swiper-wrapper');

    wrapper.removeAttribute('style');

    swiper
      .querySelectorAll('.swiper-slide')
      .forEach((slide) => {
        slide.removeAttribute('style');
      });

    const next = swiper.querySelector('.swiper-button-next');
    const prev = swiper.querySelector('.swiper-button-prev');
    const pagination = swiper.querySelector('.swiper-pagination');

    if (next) next.style.display = '';
    if (prev) prev.style.display = '';
    if (pagination) pagination.style.display = '';

    this.swiper = new Swiper(swiper, {
      slidesPerView: mobileSlides,
      spaceBetween: mobileGap,
      speed: 500,
      loop: loop,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      grabCursor: true,

      autoplay: autoplayEnabled
        ? {
            delay: speed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            waitForTransition: false
            }
        : false,

      navigation: {
        nextEl: next,
        prevEl: prev
      },

      pagination: {
        el: pagination,
        clickable: true
      },

      breakpoints: {
        750: {
          slidesPerView: desktopSlides,
          spaceBetween: desktopGap
        }
      }
    });
    if (autoplayEnabled && this.swiper.autoplay) {
    this.swiper.autoplay.start();
    }
  }
}

function initGallerySections() {
  document
    .querySelectorAll('.custom-gallery')
    .forEach((section) => {
      if (!section.galleryInstance) {
        section.galleryInstance = new CustomGallerySlider(section);
      }
    });
}

document.addEventListener('DOMContentLoaded', initGallerySections);

document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('.custom-gallery');

  if (section) {
    section.galleryInstance = new CustomGallerySlider(section);
  }
});

document.addEventListener('shopify:section:unload', (e) => {
  const section = e.target.querySelector('.custom-gallery');

  if (
    section &&
    section.galleryInstance &&
    section.galleryInstance.swiper
  ) {
    section.galleryInstance.swiper.destroy(true, true);
  }
});